var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-absolute tw-left-10",staticStyle:{"top":"calc(50vh - 7.5vw)"}},[_c('img',{staticStyle:{"width":"15vw","height":"15vw"},attrs:{"src":"/img/qr-disco.cbass.dev.png"}})])
}]

export { render, staticRenderFns }